const elemGTK = document.querySelectorAll('.wt-GoodToKnow');
window.fireOnVisible(elemGTK, async () => {
    await import('./assets/css/good_to_know.scss');
});
